import fromPairs from 'lodash.frompairs';
import React, { useEffect, useState } from 'react';
import { Canvas } from 'fabric/fabric-impl';

export interface EditorStore {
  canvas: Canvas;
  dragMode: boolean;
  prevSelectedTool: string;
  activeTextEditingMobile: boolean;
  activeObjectIText: Canvas;
  textFormat: TextFormatSettings;
  tourStepsRef: {
    index: number;
    ref: HTMLElement;
    content: string;
    positionPopper: string;
    positionPopover: string;
  }[];
}

export interface TextFormatSettings {
  fontFamily: string;
  textAlign: 'center' | 'left';
  fontStyle: '' | 'normal' | 'italic' | 'oblique';
  bold: boolean;
  color: string;
}

type Store<T> = {
  [key in keyof T | string]: any;
};

let useStore: <R, T>(key: keyof R) => [T, (value: any) => void];
let resetStore: () => void;
const setListeners = (initialStore: Store<any>) => fromPairs(Object.keys(initialStore).map((k) => [k, new Set<() => void>()]));

function createStore<T>(initialStore: Store<T>) {
  let store: Store<T> = initialStore;
  // Agrupa los listener por cada valor inicializado en el Store
  let listeners = setListeners(initialStore);

  const setDispatch = (key: string, value: any) => {
    if (typeof value === 'function') {
      store = { ...store, [key]: value(store[key]) };
    } else {
      store = { ...store, [key]: value };
    }
    listeners[key].forEach((listener) => listener());
  };

  useStore = (key: any) => {
    const [stateStore, setStateStore] = useState(store[key]);
    useEffect(() => {
      const listener = () => {
        setStateStore(store[key]);
      };
      listeners[key].add(listener);
      listener();
      return () => {
        listeners[key].delete(listener);
      };
    }, []);

    return [stateStore, (value: any) => setDispatch(key, value)];
  };

  resetStore = () => {
    store = initialStore;
    listeners = setListeners(initialStore);
  }
}

export { createStore, useStore, resetStore };
